export const mockTasks = [
  {
    id: 1,
    name: '实例到期检查',
    type: '系统任务',
    cronExpression: '0 * * * *',
    nextExecutionTime: '2024-01-15 15:00:00',
    lastExecutionTime: '2024-01-15 14:00:00',
    lastExecutionResult: 'success' as const,
    executionDuration: '2.3秒',
    status: 'enabled' as const,
    description: '每小时检查云电脑实例到期情况'
  },
  {
    id: 2,
    name: '欠费账号处理',
    type: '系统任务',
    cronExpression: '0 2 * * *',
    nextExecutionTime: '2024-01-16 02:00:00',
    lastExecutionTime: '2024-01-15 02:00:00',
    lastExecutionResult: 'success' as const,
    executionDuration: '5.8秒',
    status: 'enabled' as const,
    description: '每日凌晨2点处理欠费账号'
  },
  {
    id: 3,
    name: '数据统计汇总',
    type: '系统任务',
    cronExpression: '0 1 * * *',
    nextExecutionTime: '2024-01-16 01:00:00',
    lastExecutionTime: '2024-01-15 01:00:00',
    lastExecutionResult: 'success' as const,
    executionDuration: '12.5秒',
    status: 'enabled' as const,
    description: '每日凌晨1点进行数据统计汇总'
  },
  {
    id: 4,
    name: '日志清理',
    type: '系统任务',
    cronExpression: '0 3 * * 0',
    nextExecutionTime: '2024-01-21 03:00:00',
    lastExecutionTime: '2024-01-14 03:00:00',
    lastExecutionResult: 'success' as const,
    executionDuration: '8.2秒',
    status: 'enabled' as const,
    description: '每周日凌晨3点清理过期日志'
  },
  {
    id: 5,
    name: '数据库备份',
    type: '系统任务',
    cronExpression: '0 4 * * *',
    nextExecutionTime: '2024-01-16 04:00:00',
    lastExecutionTime: '2024-01-15 04:00:00',
    lastExecutionResult: 'success' as const,
    executionDuration: '45.6秒',
    status: 'enabled' as const,
    description: '每日凌晨4点进行数据库备份'
  },
  {
    id: 6,
    name: '发送到期提醒',
    type: '通知任务',
    cronExpression: '0 10 * * *',
    nextExecutionTime: '2024-01-16 10:00:00',
    lastExecutionTime: '2024-01-15 10:00:00',
    lastExecutionResult: 'success' as const,
    executionDuration: '3.7秒',
    status: 'enabled' as const,
    description: '每日上午10点发送云电脑到期提醒'
  },
  {
    id: 7,
    name: '清理临时文件',
    type: '系统任务',
    cronExpression: '0 5 * * *',
    nextExecutionTime: '2024-01-16 05:00:00',
    lastExecutionTime: '2024-01-15 05:00:00',
    lastExecutionResult: 'success' as const,
    executionDuration: '6.1秒',
    status: 'enabled' as const,
    description: '每日凌晨5点清理系统临时文件'
  },
  {
    id: 8,
    name: '服务器资源监控',
    type: '监控任务',
    cronExpression: '*/5 * * * *',
    nextExecutionTime: '2024-01-15 14:25:00',
    lastExecutionTime: '2024-01-15 14:20:00',
    lastExecutionResult: 'success' as const,
    executionDuration: '1.2秒',
    status: 'enabled' as const,
    description: '每5分钟监控服务器资源使用情况'
  },
  {
    id: 9,
    name: '异常订单检查',
    type: '系统任务',
    cronExpression: '0 */2 * * *',
    nextExecutionTime: '2024-01-15 16:00:00',
    lastExecutionTime: '2024-01-15 14:00:00',
    lastExecutionResult: 'failed' as const,
    executionDuration: '4.5秒',
    status: 'enabled' as const,
    description: '每2小时检查异常订单'
  }
];

export const mockTaskLogs = [
  {
    id: 1001,
    taskId: 1,
    executionTime: '2024-01-15 14:00:00',
    result: 'success' as const,
    duration: '2.3秒',
    processedCount: 156,
    errorMessage: undefined
  },
  {
    id: 1002,
    taskId: 1,
    executionTime: '2024-01-15 13:00:00',
    result: 'success' as const,
    duration: '2.1秒',
    processedCount: 142,
    errorMessage: undefined
  },
  {
    id: 1003,
    taskId: 9,
    executionTime: '2024-01-15 14:00:00',
    result: 'failed' as const,
    duration: '4.5秒',
    processedCount: 0,
    errorMessage: '数据库连接超时'
  },
  {
    id: 1004,
    taskId: 2,
    executionTime: '2024-01-15 02:00:00',
    result: 'success' as const,
    duration: '5.8秒',
    processedCount: 23,
    errorMessage: undefined
  },
  {
    id: 1005,
    taskId: 3,
    executionTime: '2024-01-15 01:00:00',
    result: 'success' as const,
    duration: '12.5秒',
    processedCount: 5420,
    errorMessage: undefined
  }
];
